const constants = {
    GET_SURVEY: 'GET_SURVEY',
    GET_SURVEY_SUCCESS: 'GET_SURVEY_SUCCESS',
    GET_SURVEY_FAILED: 'GET_SURVEY_FAILED',
    SEND_SURVEY_RESULT: "SEND_SURVEY_RESULT",
    SEND_SURVEY_RESULT_SUCCESS: "SEND_SURVEY_RESULT_SUCESS",
    SEND_SURVEY_RESULT_FAILED: "SEND_SURVEY_RESULT_FAILED",
    UPDATE_ANSWER: "UPDATE_SINGE_CHOICE_ANSWER",
    SET_URL_DATA: "SET_URL_DATA"
};
export default constants;
